import React, { useState } from "react";
import Search from "../../components/search/Search";
import { useLocation } from "react-router-dom";

export default function ModalSearch() {
  const location = useLocation();
  const [modalSearch, setModalSearch] = useState(false);
  const [currentSearchData, setCurrentSearchData] = useState(null);

  const handleSearchClick = (e, searchData = null) => {
    if (e && e.preventDefault) e.preventDefault();

    console.log(searchData);

    if (searchData) {
      setCurrentSearchData(searchData);
    } else {
      setCurrentSearchData({
        origem: "",
        destino: "",
        encomenda: "",
        seguro: "",
        origem_lat: null,
        origem_lng: null,
        destino_lat: null,
        destino_lng: null,
      });
    }

    // Rola o elemento root se ele existir
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.scrollTo({ top: 100, behavior: "smooth" });
    }

    if (location.pathname === "/") {
      window.scrollTo({ top: 100, behavior: "smooth" });

      const el = document.querySelector(".search-bar");
      if (el) {
        el.classList.add("blink-shadow");
        setTimeout(() => el.classList.remove("blink-shadow"), 1500);
      }
    } else {
      setModalSearch(true);
    }
  };

  const RenderModal = () => {
    if (!modalSearch) return null;

    return (
      <>
        <style>{`
          .modal-overlay {
            position: fixed; top: 0; left: 0; width: 100%; height: 100%;
            background: rgba(0, 0, 0, 0.4); display: flex; 
            justify-content: center; align-items: center; z-index: 1000;
          }
          .modal-content {
            background-color: #f5f5f5;
            padding: 35px;
            max-width: 1200px;
            border-radius: 999px;
          }
          
          @media (max-width: 850px) {
            .modal-content {
              background-color: transparent !important;
              padding: 0px !important;
              clip-path: none;
              overflow: visible;
              box-shadow: none;
            }
          }

          @media (max-width: 935px) {
            .modal-content {
              border-radius: 70px;
            }
          }
        `}</style>

        <div className="modal-overlay" onClick={() => setModalSearch(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <Search initialValues={currentSearchData} />
          </div>
        </div>
      </>
    );
  };

  return {
    handleSearchClick,
    RenderModal,
  };
}
